import type { UiTagType } from "@shared/components/UiTag/index.vue";
import { t } from "@shared/utils/i18n";

export type AmazonVcWarehouseKind = "PO" | "DF" | "RETURN";

export const AMAZON_VC_WAREHOUSE_KIND_OPTIONS = [
    { label: t("PO仓"), value: "PO" },
    { label: t("DF仓"), value: "DF" },
    { label: t("退件仓"), value: "RETURN" },
];

export const AMAZON_VC_WAREHOUSE_COMBINED_SEARCH_OPTIONS = [
    { label: t("仓库代码"), value: "whCode" },
    /** 仓库名称仅模糊搜索 */
    { label: t("仓库名称"), value: "whName", exact: false },
];

export const AMAZON_VC_WAREHOUSE_DATE_OPTIONS = [{ label: t("创建时间"), value: "create_date" }];

export interface AmazonVcWarehouseVcCode {
    id: string;
    code: string;
    name: string;
    type: string;
    typeLabel?: string;
}

export interface AmazonVcWarehouseRow {
    id: string;
    warehouseKind: AmazonVcWarehouseKind;
    whName: string;
    whCode: string;
    status: number;
    storeId: string;
    storeName: string;
    addressNumber: string;
    region: string;
    country: string;
    province: string;
    zone: string;
    /** 分区 code，编辑回填用 */
    zoneCode?: string;
    city: string;
    /** 城市 id，编辑回填用；列表展示优先用 city 名称 */
    cityId?: number;
    district: string;
    address1: string;
    address2: string;
    zipCode: string;
    contactName: string;
    contactPhone: string;
    contactEmail: string;
    remark: string;
    createdAt: string;
    updatedAt: string;
    amazonVcCodes: AmazonVcWarehouseVcCode[];
}

/** /manage/warehouseAmazonVc/list 返回的单条数据 */
export interface AmazonVcWarehouseItemApi {
    id: string;
    storeId: string;
    storeName: string;
    addressNumber?: string;
    vcType: AmazonVcWarehouseKind;
    warehouseCode: string;
    warehouseName: string;
    regionCode: string;
    regionLabel: string;
    zoneCode: string;
    zoneLabel: string;
    countryCode: string;
    stateCode: string;
    cityId: number;
    cityName: string;
    district: string;
    address1: string;
    address2: string;
    zipCode: string;
    contactName: string;
    contactPhone: string;
    contactEmail: string;
    remark: string;
    status: number;
    createTime: string;
    updateTime: string;
    amazonVcCodes?: AmazonVcWarehouseVcCode[];
}

/** 接口数据 → 列表行 */
export function mapAmazonVcWarehouseItem(item: AmazonVcWarehouseItemApi): AmazonVcWarehouseRow {
    return {
        id: item.id,
        warehouseKind: item.vcType,
        whName: item.warehouseName,
        whCode: item.warehouseCode,
        status: item.status,
        storeId: item.storeId,
        storeName: item.storeName,
        addressNumber: item.addressNumber ?? "",
        region: item.regionLabel || item.regionCode,
        country: item.countryCode,
        province: item.stateCode,
        zone: item.zoneLabel || item.zoneCode,
        zoneCode: item.zoneCode,
        city: item.cityName,
        cityId: item.cityId,
        district: item.district,
        address1: item.address1,
        address2: item.address2,
        zipCode: item.zipCode,
        contactName: item.contactName,
        contactPhone: item.contactPhone,
        contactEmail: item.contactEmail,
        remark: item.remark,
        createdAt: item.createTime,
        updatedAt: item.updateTime,
        amazonVcCodes: (item.amazonVcCodes ?? []).map(code => ({
            id: String(code.id),
            code: code.code || "",
            name: code.name || "",
            type: code.type || "",
            typeLabel: code.typeLabel,
        })),
    };
}

/** 状态（1-启用，2-禁用） */
export function getAmazonVcWarehouseStatusLabel(status: number): string {
    return status === 1 ? t("启用中") : t("已禁用");
}

export function getAmazonVcWarehouseStatusTagType(status: number): UiTagType {
    return status === 1 ? "success" : "neutral";
}
